export var baseLink = "https://sams.careerdose.com";
export var webLink = true;
export var getLC_Web_API = '/web/v1/liveclass/getLCS/'
export var hiring_Web_API = '/web/v1/support/hiring/'
export var session_Web_API = baseLink + '/api/v1/student/sendMails2/'
export var sessionFrench_Web_API = baseLink + '/api/v1/student/sendMails/'
export var SendMails_URL = baseLink + '/api/v1/student/sendMails/'
export var captureLeads_URL = baseLink + '/api/v1/student/captureLeads/'
export var verifyPayment_API = baseLink + '/api/v1/student/verifyPayment/'
export var createLead_API = baseLink + '/web/v1/support/contactUsLeads/'
export var mainLead_API = baseLink + '/web/v1/support/webLeads/'

export var sales_form_URL = 'https://sales.sams.careerdose.com/'
export var sales_form_API = 'api/v1/sales/salesForm/'

export let statsUrl = 'https://career-dose-stat-server.herokuapp.com/campVisit'
export let statsFrenchUrl = 'https://career-dose-stat-server.herokuapp.com/campVisitFrench'

export const desktopAppUrl = "https://sams.careerdose.com/api/v1/student/DesktopAppUpdateCheck/"